module.exports = __webpack_public_path__ + "static/img/079.5d87794.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/079.png
// module id = +8N5
// module chunks = 0